<template>
	<div class="rzy-page">
		<el-row>
			<!-- <el-button type="primary" plain>仓位库存明细</el-button> -->
			<el-button type="" plain>
				<el-link type="primary " :underline="true">{{ this.$route.query.warehouseName }}</el-link>
				<el-link>&nbsp&nbsp\&nbsp&nbsp</el-link>
				<el-link type="primary " :underline="true">{{ this.$route.query.positionName }}</el-link>
			</el-button>
		</el-row>

		<div style="margin-top: 10px;"></div>

		<el-table
			:data="responseData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ padding: '0px' }"
			border
			stripe
			id="localListTableId"
			show-summary
			:summary-method="getSummaries"
			@selection-change="handleSelectionChange"
		>
			<el-table-column label="行" type="index" :index="indexMethod" align="center"></el-table-column>

			<el-table-column sortable prop="createTime_change" label="入库时间" align="center"></el-table-column>
			<el-table-column sortable prop="inBoundNumber" label="入库单据" align="center"></el-table-column>
			<el-table-column sortable prop="juanbuNumber" label="编号" align="center" width="200">
				<template slot-scope="scope">
					<!-- <el-link v-if="scope.row.juanbu_kind == '0'" type="primary" -->
					<el-link type="primary" @click="goToDetails(scope.row.juanBuId, scope.row.juanbuNumber, scope.row.createTime_change)">{{ scope.row.juanbuNumber }}</el-link>
				</template>
			</el-table-column>
			<el-table-column sortable prop="materialNumber" label="物料编码" align="center"></el-table-column>
			<el-table-column sortable prop="materialName" label="物料名称" align="center"></el-table-column>
			<el-table-column sortable prop="XXXX" label="入库员" align="center"></el-table-column>
			<el-table-column sortable prop="unit_change" label="单位" align="center"></el-table-column>
			<el-table-column sortable prop="productLength" label="米数(米)" align="center"></el-table-column>
			<el-table-column sortable prop="productWeight_change" label="过磅重量(千克)" align="center"></el-table-column>
		</el-table>

		<el-pagination
			style="text-align: center"
			background
			layout="prev, pager, next"
			@current-change="handleCurrentChange"
			:page-size="pageInfo.size"
			:current-page="pageInfo.page"
			:page-count="totalPages"
		></el-pagination>
	</div>
</template>

<script>
export default {
	data() {
		return {
			//分页 -- sta
			pageInfo: {
				page: 1,
				size: 15,
				positionId: this.$route.query.id
			},
			totalPages: 0,
			//分页 -- end

			responseData: [
				// 调试用假数据--正式版注释掉
				{
					number: 'XXX'
				}
			]
		};
	},
	methods: {

		//暂时先这么算统计，后续可能要从后台获取统计数据
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '总计';
					return;
				}

				if (index >= 0 && index <= 7) {
					sums[index] = '';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
					if (index == 8) {
						sums[index] += ' 米';
					} else if (index === 9) {
						sums[index] += ' 千克';
					}
				} else {
					sums[index] = '';
				}
			});

			return sums;
		},

		// 在打印当前报表前，拼接title
		initPrint(id) {
			this.utils.printTable(id, `入库单列表`);
		},

		// 分页切换
		handleCurrentChange(newNum) {
			this.getPeiBuList(newNum);
		},

		// 刷新
		refreshPage() {
			this.getList(1);
			this.$Message.success('刷新成功');
		},

		// 获取XX分页列表
		getList(val) {
			this.pageInfo.page = val;
			this.$requestBase({
				url: 'v1/stock/list/stock',
				method: 'get',
				params: this.pageInfo
			}).then(res => {
				this.responseData = this.formatResponse(res.data.list);
				this.totalPages = res.data.pages;
			});
		},
		// 格式化XX列表
		formatResponse(response) {
			response.forEach((item, index) => {
				//创建时间变换
				item.createTime_change = this.utils.timestampToTime(item.createTime, 0);
				//单位变换: juanbu_kind=0显示匹，juanbu_kind=1显示包
				if (item.juanbuKind == 0) {
					item.unit_change = '匹';
				} else {
					item.unit_change = '包';
				}

				item.productLength = (item.productLength / 100).toFixed(2); //库存

				//解决bug: 过磅重量数值单位应从克 改 千克。
				item.productWeight_change = (item.productWeight / 1000).toFixed(2); //过磅重量
			});
			return response;
		},
		//给 所有 表格 自动 加行号
		indexMethod(index) {
			return index + 1;
		},

		// 路由至XX详情
		goToDetails(juanBuId, juanbuNumber, createTime_change) {
			this.$router.push({
				path: `packageDetalis`,
				query: {
					juanBuId: juanBuId,
					juanbuNumber: juanbuNumber,
					createTime_change: createTime_change
				}
			});
		}
	},
	created() {},
	mounted() {
		// console.log('this.$route.query.id=', this.$route.query.id)
		// console.log('this.$route.query.warehouseName=', this.$route.query.warehouseName)
		// console.log('this.$route.query.positionName=', this.$route.query.positionName)

		this.getList(1);
	}
};
</script>

<style scoped lang="scss"></style>
